<script>
export default {
	props: {
		text: String,
	},
	computed: {
		isHtml() {
			const v = this.text || ''
			return /<\/?[a-z][\s\S]*>/i.test(v)
		},
	},
	render(h) {
		if (!this.text) return null
		if (this.isHtml) {
			return h('div', [h('div', { domProps: { innerHTML: this.text } })])
		}

		const children = this.$slots.default || []

		// no wrapper
		if (children.length == 1) return children[0]

		// plain text
		if (!children.length) return h('div', this.text)

		// multiple nodes
		return h('div', children)
	},
}
</script>

